// extracted by mini-css-extract-plugin
export default {"switchFilter":"h6Bss","switchFilter__content":"CT5RV","switchFilter__group":"fmU1o","switchFilter__buttons":"r8b0a","appear-from-above":"ZUbBq","appearFromAbove":"ZUbBq"};